import { MstItemDetailWheelDetail } from "../../mst_wheel/types";

/**
 * Same visibility rule as WheelItemDetail list: show wheel if it has a positive
 * discounted price, user entered >= 100% special discount, or row is focused for discount edit.
 */
export function isWheelVisibleInStoreList(
  wheel: MstItemDetailWheelDetail,
  discountRateValue: string,
  focusedWheelId: number | null,
): boolean {
  return (
    wheel.discounted_price > 0 ||
    Number(discountRateValue) >= 100 ||
    wheel.id === focusedWheelId
  );
}

export function filterWheelsForStoreList(
  wheels: MstItemDetailWheelDetail[],
  discountRate: { id: number; value: string }[],
  focusedWheelId: number | null,
): MstItemDetailWheelDetail[] {
  const rateMap = new Map(discountRate.map((d) => [d.id, d.value]));
  return wheels.filter((w) =>
    isWheelVisibleInStoreList(w, rateMap.get(w.id) ?? "", focusedWheelId),
  );
}
